import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';
import { take } from 'rxjs/operators';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs009-card-V',
    templateUrl: './rs009-card-V.component.html'
})

export class Rs009CardVComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    @Output() objMakeCalculations = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Etapa 5', false);

        // Formulario v1.0
        // this.formulario = this.formBuilder.group({
        //     Total_Semente: [null, []],
        //     Rendimento: [null, []],
        //     Rendimento_Rw: [null, []],
        //     // Site_Origem: [null, []],
        //     Observacao: [null, []]
        // });

        // Formulario v1.1

        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Desconto_Umidade: [null, []],
                Peso_Liquido_Seco: [null, []],
                Rendimento_Rw: [null, []],
                Observacao: [null, []]
            });
        } else {
            this.formulario = this.formBuilder.group({
                criado_por: [null, []],
                observacao: [null, []]
            });
            this.step = 'Etapa 4'
        }
    }

    async ngOnInit(): Promise<void> {
        await this.makeCalculations();
        await this.getUser();
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    private async getUser(): Promise<void> {
        await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
          this.formulario?.get('criado_por').setValue(response['user-profile']?.displayName ?? 'Administrador');
        }).catch(async error => {
          await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
            this.formulario?.get('criado_por').setValue(response);
          }).catch(err => {
          });
        });
      }
}

